import React, { useState } from "react";
import { FiUploadCloud } from "react-icons/fi";
import "../SheetUpload/SheetBulkUploadPopup.scss";
import { useDispatch } from "react-redux";
import { SonyBulkUploadSuccess } from "../../../Redux/Slice";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { getLoaderAction } from "../../../Redux/Loader";

const SonyBulkuploadPopup = ({ setPopup }) => {
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();

  const allowedTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const MAX_SIZE = 250 * 1024 * 1024; // 250MB

  const validateFile = (uploadedFile) => {
    if (!uploadedFile) return false;

    if (!allowedTypes.includes(uploadedFile.type)) {
      toast.error("Only Excel files (.xls, .xlsx) are allowed");
      return false;
    }

    if (uploadedFile.size > MAX_SIZE) {
      toast.error("File size should be less than 250MB");
      return false;
    }

    return true;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const uploadedFile = e.dataTransfer.files[0];
    if (!validateFile(uploadedFile)) return;
    setFile(uploadedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (!validateFile(uploadedFile)) return;
    setFile(uploadedFile);
  };

  const uploadFile = () => {
    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const payload = {
      file: file,
      setPopup,
    };

    dispatch(SonyBulkUploadSuccess(payload));
  };

  const downloadSample = () => {
    getLoaderAction(true);
    const headers = [
      "Name",
      "Email",
      "Phone Number",
      "Client",
      "Designation",
      "Basic",
      "HRA",
      "Conveyance Allowance",
      "Professional Tax",
      "DOJ",
    ];

    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sample");

    XLSX.writeFile(wb, "Sony_Bulkupload_Sample.xlsx");
    getLoaderAction(false);
  };

  return (
    <div className="overlay">
      <div className="popupContainers">
        {/* Header */}
        <div className="popupHeader">
          <div />
          <span className="TitleHeader">Sony Bulkupload</span>
          <button className="closeButton" onClick={() => setPopup(false)}>
            ×
          </button>
        </div>

        {/* Sample Sheet Download */}
        <div
          className="uploadTypeHeader"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button
            className="sampleSheetBtn"
            onClick={downloadSample}
            style={{ textWrap: "nowrap", width: "35%" }}
          >
            Sample Sheet
          </button>
        </div>

        {/* Drag & Drop */}
        <div
          className="uploadBox"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <FiUploadCloud className="uploadIcon" />

          <p className="mainText">
            Click to select or drag & drop your Excel file
          </p>

          <p className="subText">Supported formats: .xls, .xlsx</p>
          <p className="subText">Max file size 250MB</p>
          <p className="subText">
            Columns: Name, Email, Phone Number, Client, Designation, Basic, HRA,
            Conveyance Allowance, Professional Tax, DOJ
          </p>
          <p className="subText">
            Basic, HRA, Conveyance Allowance, Professional Tax: required,
            numbers only, not negative (0 allowed). Decimals are rounded to
            whole rupees. DOJ: date cell, or text as DD-MM-YYYY or YYYY-MM-DD.
          </p>

          <input type="file" onChange={handleFileChange} accept=".xls,.xlsx" />

          {file && <p className="fileName">{file.name}</p>}
        </div>

        {/* Footer Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "20px",
          }}
        >
          <button
            style={{
              padding: "9px 22px",
              background: "#fff",
              border: "1px solid #d0d5dd",
              borderRadius: "8px",
              color: "#344054",
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onClick={() => setPopup(false)}
          >
            Cancel
          </button>

          <button
            className="submitBtn"
            style={{
              margin: 0,
              width: "auto",
              padding: "9px 24px",
              fontSize: "14px",
            }}
            disabled={!file}
            onClick={uploadFile}
          >
            Upload File
          </button>
        </div>
      </div>
    </div>
  );
};

export default SonyBulkuploadPopup;
